function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/** *****************************************************************************
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2019, 2025. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 ****************************************************************************** */
import locale_de from "../nls/components/components_de.json";
import locale_en_AA from "../nls/components/components_en_AA.json";
import locale_en_RR from "../nls/components/components_en_RR.json";
import locale_en_ZZ from "../nls/components/components_en_ZZ.json";
import locale_es from "../nls/components/components_es.json";
import locale_fr from "../nls/components/components_fr.json";
import locale_it from "../nls/components/components_it.json";
import locale_ja from "../nls/components/components_ja.json";
import locale_ko from "../nls/components/components_ko.json";
import locale_pt_BR from "../nls/components/components_pt_BR.json";
import locale_zh_HK from "../nls/components/components_zh_HK.json";
import locale_zh_TW from "../nls/components/components_zh_TW.json";
import locale_zh from "../nls/components/components_zh.json";
import locale_en from "../nls/components/components.json";
var translations = {
  de: locale_de,
  "en-aa": locale_en_AA,
  "en-rr": locale_en_RR,
  "en-zz": locale_en_ZZ,
  es: locale_es,
  fr: locale_fr,
  it: locale_it,
  ja: locale_ja,
  ko: locale_ko,
  "pt-br": locale_pt_BR,
  "zh-hk": locale_zh_HK,
  "zh-tw": locale_zh_TW,
  zh: locale_zh,
  en: locale_en // Default Fallback
};
var LANGUAGE_TAG_VARIANTS = {
  "zh-hans": "zh-cn",
  "zh-hant": "zh-tw"
};
export function initLocales(lang) {
  var i18nStrings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var messages = null;

  // Get the locale string
  var locale = lang || navigator.language || navigator.userLanguage;
  locale = locale && locale.toLowerCase() || "en";

  // Resolve locale
  var parts = locale.split(/[-_]/);
  while (parts.length) {
    var tag = parts.join("-");
    tag = LANGUAGE_TAG_VARIANTS[tag] || tag;
    if (translations[tag]) {
      locale = tag;
      messages = _objectSpread(_objectSpread({}, tag === "en" ? {} : translations.en), translations[tag]);
      break;
    }
    parts.pop();
  }

  // Check for fallback
  if (!messages) {
    messages = translations.en;
    locale = "en";
  }

  // Overwrite any override strings that were passed as props
  if (i18nStrings && _typeof(i18nStrings) === "object" && Object.entries(i18nStrings).length > 0) {
    messages = _objectSpread(_objectSpread({}, messages), i18nStrings);
  }
  return {
    locale: locale,
    messages: messages
  };
}
export function format(str, params) {
  if (str && str.length > 0) {
    var formatted = str;
    Object.keys(params).forEach(function (param) {
      formatted = formatted.replace("{".concat(param, "}"), params[param]);
    });
    return formatted;
  }
  return "";
}